export default {
    meete: {
        '最实用的亚洲婚恋网站': 'The most effective Asian dating website'
    }
}